
// idEnum	name	id
// 51021	商品编码	51461
// 51021	商品名称	51462
// 51021	商品图片	51463
// 51021	单价	51464
// 51022	大按钮	51465
// 51022	常规按钮	51466
// 51022	小按钮	51467
// 51023	一级	51468
// 51023	二级	51469
// 51023	末级	51470
// 51023	一级+二级	51512
// 51023	一级+末级	51513
// 51023	二级+末级	51514

const  productMap={ 
    img: "51463", 
    code: "51461", 
    name: "51462", 
    price: "51464",
    specification :"56228"
}

const cursorDefaultPosition={
    product:'51454',//51454
    member:'51455'//51455
}

const inventoryButtonSize={
    big:'51465',
    middle:'51466',
    small:'51467'
}

const voucherDefaultPosMode = {
    touch: '51459',
    voucher: '51460'
}   

const setData={
    getValue(arr,key){//return ['23433','3434']
        let obj=arr.find((el)=>el.Name===key)||{};
        let value=obj.Value|| obj.IdRef ||'';
        return value.split(',')
    },
    getObjValue(obj,key){//return {'RE_InventoryClass':['343454','343434']}
        let result={};
        let valueArr=this.getValue(obj,key);
        if(valueArr.length===1){
            result[key]=valueArr[0];
        }else{
            result[key]=valueArr;
        }
        return result;
    },
    /* 获取product 组件设置 */
    getProductConfigure(obj){
        let inventoryContent=this.getInventoryContent(obj);
        let inventoryClass=this.getObjValue(obj,'RE_InventoryClass')
        let inventoryClassNotDisplay=this.getObjValue(obj,'InventoryClassNotDisplay')
        let inventoryClassOnlyDisplay=this.getObjValue(obj,'InventoryClassOnlyDisplay')
        return {
            ...inventoryContent,
            ...inventoryClass,
            ...inventoryClassOnlyDisplay,
            ...inventoryClassNotDisplay
        }
    },   
    getInventoryContent(obj){ 
        if(!Array.isArray(obj))return;
        const key='RE_InventoryContent';
        let valueArr=this.getValue(obj,key);
        let result={};
        for(let key in productMap){
            if( !(~valueArr.indexOf(productMap[key])) ){
                result[key]=false;continue;
            }
            result[key]=true;
        }
        return result;
    },
    /* 获得按钮设置 */
    getInventoryButtonSize(obj){
        if(!Array.isArray(obj))return;
        const key='RE_InventoryButtonSize';
        let valueArr=this.getValue(obj,key);
        let result={};
        for(let key in inventoryButtonSize){
            if( (~valueArr.indexOf(inventoryButtonSize[key])) ){
                result.type=key
            }
        }
        return result;
    },
    getCursorDefaultPosition(obj){
        if(!Array.isArray(obj))return;
        const key='RE_CursorDefaultPosition';
        let valueArr=this.getValue(obj,key);
        let result={};
        for(let key in cursorDefaultPosition){
            if( (~valueArr.indexOf(cursorDefaultPosition[key])) ){
                result.cursorDefault=key
            }
        }
        return result;
    },
    getVoucherDefaultPosMode(obj) {
        if (!Array.isArray(obj)) return;
        const key = 'RE_POSMode';
        let valueArr = this.getValue(obj, key);
        let result = {};
        for (let key in voucherDefaultPosMode) {
            if ((~valueArr.indexOf(voucherDefaultPosMode[key]))) {
                result.default = key
            }
        }
        return result;
    }
}

export default setData;

